export default defineNuxtRouteMiddleware(() => {
  const { isAuth } = useAuthStore()

  if (!isAuth)
    return navigateTo('/login', { replace: true })
})
